module.exports = __webpack_public_path__ + "img/logo-srp-combinated.52636f78.svg";